import React from 'react';
import styled from 'styled-components';
import { Button, Spin } from 'antd';
import useDownloadGuard from '../hooks/useDownloadGuard';

const StyledButton = styled(Button)`
  background: ${props => props.disabled ? '#F3F4F6' : '#4F46E5'};
  color: ${props => props.disabled ? '#9CA3AF' : 'white'};
  border: none;
  border-radius: 4px;
  padding: 4px 16px;
  height: 32px;
  margin-left: 20px;

  &:hover {
    background: ${props => props.disabled ? '#F3F4F6' : '#3C3AAE'};
    color: ${props => props.disabled ? '#9CA3AF' : 'white'};
    border: none;
  }

  position: relative;
  min-width: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  
  .loading-container {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .ant-spin {
    margin-right: 4px;
  }

  &:disabled {
    background: #f5f5f5;
    border-color: #d9d9d9;
    color: rgba(0, 0, 0, 0.25);
    cursor: not-allowed;
  }
`;

const ViewReportButton = ({
  onClick,
  disabled,
  loading,
  endTime,
  'aria-label': ariaLabel
}) => {
  const isAvailable = true;
  // Self-guarded: the button owns its in-flight state, so a rage-click on one
  // row cannot fire the report request twice (or spin every other row).
  const dl = useDownloadGuard(onClick, { disabled });
  const isThisButtonLoading = dl.loading || loading;
  return (
    <StyledButton
      onClick={dl.onClick}
      disabled={dl.disabled}
      aria-label={ariaLabel}
      title={dl.disabled ? "Report generation in progress" : ""}
    >
      {isThisButtonLoading ? (
        <div className="loading-container">
          <Spin size="small" />
          <span>Generating PDF...</span>
        </div>
      ) : isAvailable ? (
        'View Report'
      ) : (
        'Report in Progress'
      )}
    </StyledButton>
  );
};

export default ViewReportButton;